export function formatPrice(n) {
  const v = Number(n) || 0;
  return `${v.toLocaleString("fr-FR").replace(/[ ,\u202f\u00a0]/g, ".")} FCFA`;
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return "";
  }
}

export function statusLabel(status) {
  const map = {
    en_attente: "En attente",
    confirmee: "Confirmée",
    en_livraison: "En cours de livraison",
    livree: "Livrée",
    annulee: "Annulée",
  };
  return map[status] || status;
}

export const DAKAR_QUARTIERS = [
  "Almadies", "Ngor", "Ouakam", "Mermoz", "Sacré-Cœur", "Plateau", "Fann",
  "Médina", "Yoff", "Grand Yoff", "Parcelles Assainies", "Keur Massar",
  "Rufisque", "Autre quartier de Dakar",
];
